import { OSShell } from '../../src/components/os-shell/OSShell'

export function Page() {
  return <OSShell />
}
